import React from 'react';
import { datafluxRum } from '@cloudcare/browser-rum';

type GlobalErrorBoundaryState = {
  hasError: boolean;
};

class GlobalErrorBoundary extends React.Component<
  React.PropsWithChildren,
  GlobalErrorBoundaryState
> {
  state: GlobalErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): GlobalErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Unhandled application error:', error, errorInfo);
    datafluxRum?.addError(error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <main
          className="flex min-h-screen w-full flex-col items-center justify-center gap-4 px-4 text-center"
          role="alert"
        >
          <p className="text-base text-gray-700">
            <span>Something went wrong. Please reload the page.</span>
          </p>
          <button
            type="button"
            className="rounded bg-[#FB6011] px-5 py-2 text-white"
            onClick={() => window.location.reload()}
          >
            <span>Reload page</span>
          </button>
        </main>
      );
    }

    return this.props.children;
  }
}

export default GlobalErrorBoundary;
